module.exports = __webpack_public_path__ + "static/media/logo-sicredi.b897827b.svg";